export const styles = {
  modalClass: "!p-0 md:pr-11 flex p-0 flex-col !rounded lg:!w-6/12 !w-full",
  headerClass:
    "!mt-0 items-center text-white sticky h-24 pr-4 pl-[42%] bg-primary font-bold text-2xl",

  receiveLinkWrapper: "flex flex-col items-center my-8",
  receiveLinkTitle: "font-semibold text-[20px]",
  copyLinkText: "text-xs font-semibold",
  linkActiveNote: "text-[10px] font-normal text-[#949494]",
  linkSentMessage: "text-[15px] w-1/2 text-center font-normal text-[#969696]",

  sendOptionButton:
    "flex min-w-[220px] cursor-pointer justify-start mx-4 items-center rounded-lg p-5",

  awaitingWrapper: "flex flex-col items-center py-10",
  awaitingTitle: "text-center text-[15px] lg:text-[20px] text-primary font-semibold",
  awaitingNote: "text-[15px] lg:text-[20px] font-semibold",

  dotsWrapper: "flex space-x-2 animate-pulse mb-10",
  dot: "w-3 h-3 bg-gray-500 rounded-full",

  resendBtn:
    "border border-primary text-white font-semibold py-2 px-4 rounded-full text-[15px] lg:text-[20px]",

  signedWrapper: "flex flex-col items-center py-10",
  signedTitle: "text-[20px] lg:text-[25px] font-bold",
  signedSubtitle: "text-[15px] lg:text-[20px] font-semibold",
  signedLink: "cursor-pointer text-[15px] lg:text-[20px] text-primary font-bold",
};
